import React from 'react';

export default class OrderSummary extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log("OrderSummary", this.props)
		return (
			<div className="OrderSummaryCard text-black bg-white mt-4 lg:mt-0">
				<div
					className={`w-full px-6 py-4 ${this.props.hasBorder &&
						'border border-gray-300 rounded-md shadow-sm'}`}
				>
					<h2 className="text-md md:text-xl text-center pb-4">Order Summary</h2>
					<div className="text-sm md:text-lg">
						<div className="py-2">
							<p className="inline-block">Subscription</p>
							<p className="inline-block float-right">$25.00</p>
						</div>
						<div className="py-2">
							<p className="inline-block">License Setup Fee</p>
							<p className="inline-block float-right">$175.00</p>
						</div>
						<hr />
						<div className="py-2">
							<p className="inline-block">Total</p>
							<p className="inline-block float-right">$200.00</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
